import * as React from "react";
import { useState, useEffect } from "react";
import { Token } from "../Models/Token";
import { CustomError } from "../Models/CustomError";
import axios, { AxiosRequestConfig } from "axios";
import { RouteComponentProps } from "react-router-dom";
import { Formik } from "formik";
import { ValidationError } from "../Models/ValidationErrors";
import { Button } from "react-bootstrap";
import { isCustomError } from "../Utils";

interface IProps extends RouteComponentProps {
    onLogin: (token: Token) => void;
}

export const Login = (props: IProps): JSX.Element => {
    const [reqErrors, setReqErrors] = useState<CustomError>();
    const { onLogin, history } = props;

    useEffect(() => {
        async function isUserAuth() {
            if (history?.location?.state === "/") return;
            try {
                const token = localStorage.getItem("token");
                const refreshToken = localStorage.getItem("refreshToken");

                //if either empty do nothing
                if (!token || !refreshToken) {
                    return;
                }

                let config: AxiosRequestConfig = {};
                config.data = {
                    token: token,
                    refreshToken: refreshToken,
                };

                await axios.get(
                    process.env.REACT_APP_API_URL + "/api/v1/identity/isuserauth",
                    config
                );

                const tokenObj = {
                    token: token,
                    refreshToken: refreshToken,
                };
                onLogin(tokenObj);

                //redirect to home
                history?.push("/","/login");
            } catch (error) {
                if(isCustomError(error)){
                    setReqErrors(error);
                }
            }
        }

        isUserAuth();
    });

    const onForgotPassword = () => {
        history?.push("/forgotpwd");
    };

    return (
        <div className="row justify-content-center">
            <div className="col-4">
                <Formik
                    initialValues={{ email: "", pwd: "" }}
                    onSubmit={async (values, { setSubmitting }) => {
                        console.log(values);

                        //login
                        try {
                            const response = await axios.post(
                                process.env.REACT_APP_API_URL + "/api/v1/identity/login",
                                { email: values.email, password: values.pwd }
                            );
                            const tokenObj = response.data as Token;
                            onLogin(tokenObj);

                            //redirect to home
                            history?.push("/");
                        } catch (error) {
                            if(isCustomError(error)){
                                setReqErrors(error);
                            }
                        }

                        setSubmitting(false);
                    }}
                    validate={(values) => {
                        const errors: ValidationError = {
                            email: "",
                            pwd: "",
                        };

                        if (!values.email) {
                            errors.email = "Required";
                        } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                values.email
                            )
                        ) {
                            errors.email = "Invalid email address";
                        }

                        if (!values.pwd) {
                            errors.pwd = "Required";
                        }

                        if (errors.email !== "" || errors.pwd !== "")
                            return errors;

                        return {};
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Email address:</label>
                                <input
                                    className="form-control"
                                    required
                                    type="email"
                                    placeholder="email"
                                    id="email"
                                    name="email"
                                    onChange={handleChange("email")}
                                    onBlur={handleBlur}
                                    value={values.email}
                                />
                                {touched.email && (
                                    <small className="form-text text-muted">
                                        {errors.email}
                                    </small>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Password:</label>
                                <input
                                    className="form-control"
                                    required
                                    type="password"
                                    placeholder="password"
                                    id="pwd"
                                    name="pwd"
                                    onChange={handleChange("pwd")}
                                    onBlur={handleBlur}
                                    value={values.pwd}
                                />
                                {touched.pwd && (
                                    <small className="form-text text-muted">
                                        {errors.pwd}
                                    </small>
                                )}
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                Login
                            </button>

                            {reqErrors?.errors?.map(
                                (error: string) => (
                                    <small className="form-text text-muted">
                                        {error}
                                    </small>
                                )
                            )}
                        </form>
                    )}
                </Formik>
                <div>
                    <Button variant="link" onClick={onForgotPassword}>Forgot Password</Button>
                </div>
            </div>
        </div>
    );
};
